import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  // DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing values to be safe
  // to use in the different DOM contexts.

  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    // return this.sanitizer.sanitize(SecurityContext.URL, url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
